export const locations = {
  filenameBase: 'locations',
  filenameExtension: 'geojson',
  schema: [
    {
      name: 'geojson',
      type: 'text',
    },
  ],
};
